import PropTypes from 'prop-types';

import { Card } from '@/components/reports/card';

import ImpressionResult from './ImpressionResult';
import { CardTitle } from './utils'

export default function PathSessionResult({ data }) {
  if (!data.length) return null

  return (
    <Card title={<CardTitle title="Path Sessions" subtitle={`total: ${data && data.length || 0}`} />}>
      {data.map(pathSession => {
        const pathActions = pathSession.impressions.filter(pathAction => pathAction.action !== 'finish')
        return <>
          <Card
            key={pathSession.id}
            title={<CardTitle title={`Path Session Id: ${pathSession.id}`} />}>
            <ImpressionResult data={pathActions} />
          </Card>
        </>
      })}
    </Card>
  )
}

const propTypes = { data: PropTypes.object }
PathSessionResult.propTypes = propTypes
PathSessionResult.defaultProps = { data: [] }
